<div class="sub-id-control__header">
  <div class="row">
    <adxad-form-field class="col sub-id-control__field">
      <adxad-input
        [placeholder]="target?.placeholder ? (target.placeholder | transloco) : 'Add ID'"
        [(ngModel)]="inputValue"
        (keypress)="keyboardListener($event)"
      ></adxad-input>
    </adxad-form-field>

    <div class="col-auto">
      <button
        (click)="add()"
        [disabled]="disabledAddBtn"
        adxadButton
      >
        {{ 'action_add' | transloco }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="control.value?.length">
    <div class="row">
      <adxad-label class="col"> {{ 'label_selected' | transloco }} </adxad-label>

      <div
        (click)="clearAll()"
        class="col-auto sub-id-control__clear-btn"
      >
        {{ 'action_clearAll' | transloco }}
      </div>
    </div>

    <div class="sub-id-control__search">
      <span class="material-icons sub-id-control__search-icon">search</span>

      <input
        class="sub-id-control__search-field"
        placeholder="Search"
        [(ngModel)]="filterSelectedValue"
      />
    </div>
  </ng-container>
</div>

<div
  class="sub-id-control__list"
  *ngIf="control.value?.length"
>
  <div
    class="sub-id-control__list-item"
    *ngFor="let value of filteredValue; let i = index"
  >
    {{ value }}
    <span
      (click)="remove(value)"
      class="material-icons"
      >close</span
    >
  </div>
</div>
